import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import Table from '../../components/Table'
import { metodoPrograma } from '../../components/api'
import { Autocomplete } from '@mui/material'
import {
  IconButton,
  Grid,
  TextField as MaterialTextField,
} from '@material-ui/core'
import { IoReload } from 'react-icons/io5'
import { MdDelete } from 'react-icons/md'
import translations from '../../translations'

const ListaUsuario = ({
  contratante,
  setUsuarioAberto,
  setTela,
  idTipoUsuario,
  setIdTipoUsuario,
}) => {
  const [lista, setLista] = useState([])
  const [tiposUsuario, setTiposUsuario] = useState([])
  const t = translations[navigator.language.split('-')[0].toUpperCase()] || translations['PT'];

  const buscaLista = useCallback(async () => {
    const dados = {
      idContratante: contratante[0],
      idTipoUsuario,
      CnstPagnation: [1000, 1, '', []],
    }
    const res = await metodoPrograma('lista', dados)
    setLista(res.lista || [])
  }, [contratante, idTipoUsuario])

  const buscaTipoUsuario = useCallback(async () => {
    metodoPrograma('listaTiposUsuario').then((res) =>
      setTiposUsuario(res.lista),
    )
  }, [])

  useEffect(() => {
    buscaTipoUsuario()
    buscaLista()
  }, [buscaLista, buscaTipoUsuario])

  const handleClick = (_, linha) => {
    setUsuarioAberto(linha)
    setTela('edicao')
  }

  const exclui = (idUsuario) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        t.confirmaExclusao,
      )
    )
      return
    await metodoPrograma('exclui', { idUsuario })
    await buscaLista()
  }

  const handleChange = (event, newValue) => {
    setIdTipoUsuario(newValue?.tipo ||-1)
    buscaLista()
  }

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
        <Autocomplete
          name="tpUsuario"
          component={Autocomplete}
          options={tiposUsuario}
          onChange={handleChange}
          getOptionLabel={(option) => (option.tipo ? option.desc : '')}
          getOptionSelected={(o, v) => o?.tipo === v?.tipo}
          noOptionsText="Não Encontrado"
          clearText="Limpar"
          openText="Abrir"
          renderInput={(params) => (
            <MaterialTextField
              margin="dense"
              variant="outlined"
              label="User Type"
              {...params}
            />
          )}
        />
      </Grid>
      <Table
        dados={lista}
        head={['ID', 'Type', 'E-mail', 'Name', 'Inclusion', 'Deletion', '']}
        line={(l) => [l[0], l[1][1], l[2], l[3], l[4], l[5], '']}
        onClick={handleClick}
        columnOptions={[
          {
            alias: 6,
            customJsx: ({ linhaOriginal }) => (
              <IconButton size="small" onClick={exclui(linhaOriginal[0])}>
                {linhaOriginal[5] ? <IoReload /> : <MdDelete />}
              </IconButton>
            ),
          },
        ]}
      />
    </>
  )
}

export default memo(ListaUsuario, isEqual)
